import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    error: false,
    errorPhrase: "",
    info: false,
    infoPhrase: ""
}

const logInSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        signInError: (state,action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        signInInfo: (state,action) => {
            state.info = true
            state.infoPhrase = action.payload.infoPhrase
        },
        reset: state => initialState,
    },
})

export const { signInError, signInInfo, reset } = logInSlice.actions
export default logInSlice.reducer